import React from "react"
import PropTypes from "prop-types"
import ImPropTypes from "react-immutable-proptypes"
import Im from "immutable"
import { createDeepLinkPath, sanitizeUrl } from "core/utils"
import { isArray } from 'lodash'

export default class OperationTag extends React.Component {

  static defaultProps = {
    tagObj: Im.fromJS({}),
    tag: "",
  }

  static propTypes = {
    tagObj: ImPropTypes.map.isRequired,
    tag: PropTypes.string.isRequired,

    layoutSelectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,

    getConfigs: PropTypes.func.isRequired,
    getComponent: PropTypes.func.isRequired,

    children: PropTypes.element,
  }

  renderTableData = (jsMetaData) => {
    if (jsMetaData && isArray(jsMetaData.tableData)) {
      const data = jsMetaData.tableData;
      const headers = Object.keys(data[0])
      return <div className="metadata-table">
            <table className="metadata-table">
              <tr>
                {headers.map((header) => <th>{header}</th>)}
              </tr>
                {data.map((row) => {
                  return <tr>{Object.keys(row).map((key, index) =>  { 
                    if (key === "customDescription") {
                    return <td dangerouslySetInnerHTML={{ __html: row[key] }}></td>
                  }
                  return <td>{row[key]}</td>})}
                  </tr>
                })}
            </table>
          </div>
      }
    return null
  }

  render() {
    const {
      tagObj,
      tag,
      children,

      layoutSelectors,
      layoutActions,
      getConfigs,
      getComponent,
    } = this.props

    let {
      docExpansion,
      deepLinking,
    } = getConfigs()
    const isDeepLinkingEnabled = deepLinking && deepLinking !== "false"

    const Collapse = getComponent("Collapse")
    const Markdown = getComponent("Markdown")
    const DeepLink = getComponent("DeepLink")

    let tagDescription = tagObj.getIn(["tagDetails", "description"], null)
    let tagName = tagObj.getIn(["tagDetails", "name"], null)
    let metaData = tagObj.getIn(["tagDetails", "metaData"], null)
    let tagExternalDocsDescription = tagObj.getIn(["tagDetails", "externalDocs", "description"])
    let tagExternalDocsUrl = tagObj.getIn(["tagDetails", "externalDocs", "url"])

    let isShownKey = [createDeepLinkPath(tag)]
    let showTag = layoutSelectors.isShown(isShownKey, docExpansion === "full" || docExpansion === "list")
    const jsMetaData = metaData ? metaData.toJS() : null
    return (
      <div className={showTag ? "opblock-tag-section is-open" : "opblock-tag-section"} >

        <h4
          onClick={() => layoutActions.show(isShownKey, !showTag)}
          className={!tagDescription ? "opblock-tag no-desc" : "opblock-tag" }
          id={isShownKey}>
 {tag !== "Mineral Embedded" && (
            tag.indexOf("Embedded Compliance Intelligence") !== -1 ? (
              <a className="nostyle"
                onClick={isDeepLinkingEnabled ? (e) => e.preventDefault() : null}
                href={isDeepLinkingEnabled ? `#/${tag}` : null}>
                <span>Intelligence Core Library</span>
              </a>
            ) : tag === "Multi Client Admin Assignments" ? (
              <a className="nostyle"
                onClick={isDeepLinkingEnabled ? (e) => e.preventDefault() : null}
                href={isDeepLinkingEnabled ? `#/${tag}` : null}>
                <span>Multi Client Admin<br />Assignments</span>
              </a>
            ) : (
              <DeepLink
                enabled={isDeepLinkingEnabled}
                isShown={showTag}
                path={tag}
                text={tag}
              />
            )
          )}
          { !tagDescription ? <small></small> :
            <small>
                <Markdown source={tagDescription} />
              </small>
            }

            <div>
              { !tagExternalDocsDescription ? null :
                <small>
                    { tagExternalDocsDescription }
                      { tagExternalDocsUrl ? ": " : null }
                      { tagExternalDocsUrl ?
                        <a
                            href={sanitizeUrl(tagExternalDocsUrl)}
                            onClick={(e) => e.stopPropagation()}
                            target={"_blank"}
                            >{tagExternalDocsUrl}</a> : null
                          }
                  </small>
                }
            </div>

            {tag !== "Mineral Embedded" && (
              <button
                className="expand-operation"
                title={showTag ? "Collapse operation" : "Expand operation"}
                onClick={() => layoutActions.show(isShownKey, !showTag)}>

                <svg className="arrow" width="20" height="20">
                  <use href={showTag ? "#large-arrow-down" : "#large-arrow"} xlinkHref={showTag ? "#large-arrow-down" : "#large-arrow"} />
                </svg>
              </button>
            )}

        </h4>

        <Collapse isOpened={showTag} metaData={metaData}>
          {this.renderTableData(jsMetaData)}
          {children}
          {tag.indexOf("Intelligence Core Library") !== -1 && (() => {
            const ECIQuickGuide = getComponent("ECIQuickGuide", true)
            return ECIQuickGuide ? (
              <div id="eci-quick-guide">
                <ECIQuickGuide getComponent={getComponent} />
              </div>
            ) : null
          })()}
        </Collapse>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/core/components/operation-tag.jsx